<template>
  <div class="common-header">
    <div class="wrapper">
      <div class="logo"></div>
      <div class="navigation">
        <div v-if="isShowAppLink" class="navigation-item">
          <div class="app">
            <DownloadAppPopover/>
            <!-- <a class="app-label link" href="/download-app/">{{ $t('admin.layout.header.app') }}</a> -->
          </div>
          <div class="widget" @click="handleWidgetIconClick">
            <i class="widget-icon iconfont icona-bianzu59"></i>
          </div>
        </div>
        <div v-if="isShowOfficialAccount" class="navigation-item">
          <div class="official-acount">
            <div class="sina-acount">
              <span class="sina-icon"></span>
            </div>
            <div class="wechat-acount">
              <span class="wechat-icon"></span>
              <div class="wechat-tooltip"></div>
            </div>
          </div>
        </div>
        <div v-show="hasLogin" class="navigation-item">
          <HeaderUserMenu/>
        </div>
        <div v-show="!hasLogin" class="navigation-item">
          <HeaderNoLoginMenu/>
        </div>
        <div class="navigation-item">
          <div class="language link" @click="handleLanguageBtnClick">{{ anotherLanguage }}</div>
        </div>
        <div class="navigation-item">
          <div class="hotline hover-dropdown">
            <span class="hotline-icon"></span>
            <div class="hover-dropdown-wrapper">
              <div class="hover-dropdown-body hotline-detail">
                <div class="detail-line">
                  <span class="line-label">{{ $t('admin.layout.header.hotline.cnUser') }}</span>
                  <span class="line-content phone">400-990-3308</span>
                </div>
                <div class="detail-line">
                  <span class="line-label">{{ $t('admin.layout.header.hotline.allUser') }}</span>
                  <span class="line-content email link">service@ajinga.com</span>
                </div>
              </div>
              <div class="hover-dropdown-arrow"></div>
            </div>
          </div>
        </div>
        <div v-if="isShowShareList" class="navigation-item">
          <div class="share hover-dropdown">
            <span class="share-icon"></span>
            <div class="hover-dropdown-wrapper">
              <div class="hover-dropdown-body share-list">
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
                <div class="share-item"></div>
              </div>
              <div class="hover-dropdown-arrow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HeaderUserMenu from './headerUserMenu'
import HeaderNoLoginMenu from './headNoLoginMenu'
import DownloadAppPopover from './downloadAppPopover.vue'

export default {
  components: {
    HeaderUserMenu,
    HeaderNoLoginMenu,
    DownloadAppPopover
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount', 'isCompanyAccount']),
    currentAccount () {
      return this.getCurrentAccount
    },
    hasLogin () {
      if (this.currentAccount.id) {
        return true
      } else {
        return false
      }
    },
    isShowAppLink () {
      return this.isCompanyAccount
    },
    isShowOfficialAccount () {
      return false
    },
    isShowShareList () {
      return false
    },
    anotherLanguage () {
      if (this.$i18n.locale === 'en') {
        return '简体中文'
      } else {
        return 'English'
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    handleLanguageBtnClick () {
      let languageParam = 'en'
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
        languageParam = 'zh-cn'
      } else {
        this.$i18n.locale = 'en'
      }
      this.changeLanguage(languageParam)
      this.reloadPage()
    },
    handleWidgetIconClick () {
      this.$router.push('/v-admin/widget-installation')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  position: relative;
  background-color: #3a3a3a;
  color: #fff;

  .wrapper {
    display: flex;
    width: 1002px;
    height: 52px;
    margin: 0 auto;

    .logo {
      width: 178px;
      height: 38px;
      background: url($baseDomain + 'static/images_en/sprite_logo.png?t=1') no-repeat 0 0;
      margin: auto;
      margin-left: 0;
    }

    .navigation {
      display: flex;
      height: 52px;
      padding: 0 8px;
      position: absolute;
      right: 0;
      font-size: 12px;

      .navigation-item {
        height: 12px;
        padding: 0 16px;
        margin-top: auto;
        margin-bottom: auto;

        &:first-child {
          padding-left: 0px;
        }

        &:not(:last-child) {
          border-right: 1px solid #bfbfbf;
        }

        & > div {
          position: relative;
          top: -8px;
          height: 30px;
          line-height: 30px;

           & > * {
             vertical-align: middle;
           }
        }

        .app {
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          top: -10px;

          .app-icon {
            font-size: 22px;
          }
        }

        .widget {
          display: inline-block;
          margin-left: 16px;
          vertical-align: middle;
          cursor: pointer;
          top: -10px;

          .widget-icon {
            font-size: 22px;
          }
        }

        .official-acount {
          display: flex;

          .sina-acount {
            .sina-icon {
              display: block;
              width: 30px;
              height: 29px;
              background: url($baseDomain + 'static/images_en/sina_logo.png') no-repeat center center;
              background-size: 29px 29px;
              cursor: pointer;
            }
          }

          .wechat-acount {
            margin-left: 16px;
            position: relative;

            &:hover {
              .wechat-tooltip {
                display: block;
              }
            }

            .wechat-icon {
              display: block;
              background: url($baseDomain + 'static/images_en/icon_wechat.png') no-repeat center center;
              background-size: 29px 29px;
              width: 30px;
              height: 29px;
              cursor: pointer;
            }

            .wechat-tooltip {
              display: none;
              width: 305px;
              height: 305px;
              background: url($baseDomain + 'static/images_en/wechat_code.jpg') no-repeat center center;
              background-size: 300px 300px;
              position: absolute;
              top: 40px;
              right: -50px;
            }
          }
        }

        .hot-line {
          top: -9px;
        }

        .hover-dropdown {
          position: relative;
          cursor: pointer;

          &:hover {
            .hover-dropdown-wrapper {
              display: block;
            }
          }

          .hover-dropdown-wrapper {
            display: none;
            width: 60px;
            position: absolute;
            right: -17px;
            z-index: 1;

            &:hover {
              display: block;
            }

            .hover-dropdown-body {
              margin-top: 20px;
              padding: 10px 5px;
              background: #fff;
              border: 1px solid #aaa;
              border-radius: 10px;
              position: relative;
              right: 185px;
            }

            .hover-dropdown-arrow {
              width: 22px;
              height: 15px;
              background: url($baseDomain + 'static/image/list_assets.png?t=5') no-repeat -20px -142px;
              position: absolute;
              top: 8px;
              right: 18px;
            }
          }
        }

        .hotline {
          .hotline-icon {
            display: block;
            width: 26px;
            height: 29px;
            background: url($baseDomain + 'static/images_en/sprite_logo.png') no-repeat -157px -60px;
          }

          .hotline-detail {
            width: 244px;

            .detail-line {
              height: 21px;
              line-height: 21px;

              .line-label {
                display: inline-block;
                width: 85px;
                padding-left: 10px;
                color: #333;
              }

              .line-content {
                padding-left: 10px;
                font-size: 14px;

                &.phone {
                  color: #ff6633;
                }
                &.email{
                  text-decoration: underline;
                }
              }
            }
          }
        }

        .share {
          .share-icon {
            display: block;
            width: 26px;
            height: 29px;
            background: url($baseDomain + 'static/images_en/share_icon.png') no-repeat center center;
          }

          .share-list {
            width: 214px;
            line-height: 0;

            &.hover-dropdown-body {
              right: 148px;
            }

            .share-item {
              display: inline-block;
              width: 30px;
              height: 30px;
              margin: 2px;
              margin-left: 7px;
            }
          }
        }
      }
    }
  }

}
</style>
